export default __webpack_public_path__ + "38f46885ba693ceb0b13a61f34af7a73.png";